import {useBasketMinimalState} from '@aboutyou/user';
import {useEffect, useRef} from 'react';
import {CheckoutEventsData} from '../CheckoutWebComponent/types';

export const useUpdateBasketState = () => {
  const countOfProducts = useRef<number>(0);
  const {refetch: refetchBasketMinimalState} = useBasketMinimalState();
  const triggerCleanup = useRef(false);
  useEffect(() => {
    // the `update` event is triggered when the basket state changes
    // we want to refetch the basket minimal state on leaving the checkout page if the basket state has changed
    return () => {
      if (triggerCleanup.current) {
        refetchBasketMinimalState();
      }
    };
  }, []);

  return {
    updateBasketState: (props: CheckoutEventsData['update']) => {
      if (triggerCleanup.current) {
        return;
      }
      let currentCount = 0;
      if ('detail' in props && props.detail?.orderState?.basket?.packages) {
        props.detail.orderState.basket.packages.forEach(basketPackage => {
          basketPackage.items.forEach(item => {
            currentCount += item.quantity;
          });
        });

        if (
          countOfProducts.current !== 0 &&
          currentCount !== countOfProducts.current
        ) {
          triggerCleanup.current = true;
        }

        countOfProducts.current = currentCount;
      }
    },
  };
};
